import React, { useEffect } from "react";
import bg_image from "../../assets/reasons_8_bg.jpg";
import reason_8_mobile from "../../assets/reason8.jpg"
import waves from "../../assets/large_wave.jpg";
import reason_1 from "../../assets/reason_1.jpg";
import reason_2 from "../../assets/reason_2.jpg";
import reason_3 from "../../assets/reason_3.jpg";
import reason_4 from "../../assets/reason_4.jpg";
import reason_5 from "../../assets/reason_5.jpg";
import reason_6 from "../../assets/reason_6.jpg";
import reason_7 from "../../assets/reason_7.jpg";
import reason_8 from "../../assets/reason_8.jpg";
import reason_2_small from "../../assets/reason_2_small.jpg";
import reason_3_small from "../../assets/reason_3_small.jpg";
import reason_4_small from "../../assets/reason_4_small.jpg";
import reason_5_small from "../../assets/reason_5_small.jpg";
import reason_6_small from "../../assets/reason_6_small.jpg";
import reason_7_small from "../../assets/reason_7_small.jpg";
import reason_8_small from "../../assets/reason_8_small.jpg";
import reason_small from "../../assets/reason_small.jpg";
import CircleIcon from "@mui/icons-material/Circle";
const Reason8 = () => {
   useEffect(() => {
        window.scrollTo({
          top: 0,
          behavior: "smooth",
        });
      }, []);
  return (
    <>
      <div className="bg-[#ecdccd] relative w-full md:block hidden">
        <img
          src={bg_image}
          alt=""
          className="object-cover lg:h-auto md:h-[600px] h-[650px] xs:h-[550px]"
        />
        <div className="top-0 absolute w-full h-full flex justify-center font-lexend 3xl:pt-40 2xl:pt-24 xl:pt-16 pt-14  z-10">
          <div className="w-4/5 xl:w-11/12 2xl:w-[80rem] 3xl:w-3/4  mx-auto font-lexend pt-20 sm:pt-14 xs:pt-10 flex justify-between flex-col ">
            <h1 className="xl:text-6xl sm:text-2xl xxs:text-xl text-4xl uppercase text-white font-extralight leading-tight ">
              <span className="font-semibold">8 reasons </span>to choose{" "}
              <br className="md:block hidden" /> a Moondew mattress
            </h1>
            <div className="3xl:pb-16 pb-8">
              <h2 className="xl:text-5xl  text-3xl sm:text-xl xxs:text-lg mt-3 xl:pt-0 text-[#f4e391] font-extralight leading-tight ">
                Choosing the right mattress
                <br className="md:block hidden" />
                is not just about comfort.
              </h2>
              <p className="text-lg xs:text-sm  font-light  text-white 3xl:py-9 py-5">
                It affects how your body feels, how well you sleep, and how you
                show up every day.
              </p>
              <p className="text-lg xl:w-1/2 w-full xs:text-sm  sm:pe-0 pe-5 font-light text-white">
                Over time, poor sleep can show up in ways we often ignore. A
                stiff back, constant fatigue, trouble focusing, mood changes,
                even long-term health concerns. What you sleep on plays a bigger
                role than you think.
              </p>
              <p className="text-lg font-light xs:text-sm  text-white xl:py-9 py-5">
                Here’s why a natural latex mattress makes a difference.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div className="bg-[#ecdccd] relative w-full font-lexend md:hidden block pt-5 ">
        <img
          src={reason_8_mobile}
          alt=""
          className="h-full"
        />
        <div className="top-0 absolute w-full h-full flex justify-center 3xl:pt-40 2xl:pt-24 xl:pt-16 pt-14  z-10">
          <div className="w-4/5 xl:w-11/12 2xl:w-[80rem] 3xl:w-3/4  mx-auto font-lexend pt-20 sm:pt-14 xs:pt-10 ">
            <h1 className=" sm:text-2xl xxs:text-xl text-4xl uppercase text-white font-extralight text-center xxs:pt-0 pt-5 leading-tight ">
              <span className="font-semibold">8 reasons </span>to choose{" "}
              <br className="md:block hidden" /> a Moondew mattress
            </h1>
           
          </div>
        </div>
         <div className=" p-6 bg-[#6e5844]">
              <h2 className="  text-3xl sm:text-xl  xl:pt-0 text-[#f4e391] font-light font-lexend leading-tight ">
                Choosing the right mattress
                <br className="" />
                is not just about comfort.
              </h2>
              <p className="text-lg xs:text-sm  font-light  text-white 3xl:py-9 py-5">
                It affects how your body feels, how well you sleep, and how you
                show up every day.
              </p>
              <p className="text-lg  w-full xs:text-sm font-light text-white">
                Over time, poor sleep can show up in ways we often ignore. A
                stiff back, constant fatigue, trouble focusing, mood changes,
                even long-term health concerns. What you sleep on plays a bigger
                role than you think.
              </p>
              <p className="text-lg font-light xs:text-sm  text-white xl:py-9 py-5">
                Here’s why a natural latex mattress makes a difference.
              </p>
            </div>
      </div>

      <div className="w-full bg-[#3a683f] sm:pb-0 pb-10 font-lexend">
        <div className="p-6 md:w-4/5 md:p-0 xl:w-11/12 2xl:w-[80rem] 3xl:w-3/4  mx-auto font-lexend relative ">
          <div className="top-0 absolute left-72 xl:block hidden z-0">
            <img src={waves} alt="" className="w-full h-full " />
          </div>
          <div className="flex xl:flex-row flex-col xl:gap-14  ">
            <div className="3xl:w-[630px] xl:w-[690px] xl:h-[560px] w-full flex justify-start items-center relative overflow-hidden">
              <div className="z-10 relative">
                <div className="absolute right-0 md:w-24 md:h-24 w-12 h-12 bg-[#f4e391] flex justify-center items-center font-lexend md:text-6xl text-3xl font-extralight text-[#2f5a33]">
                  1
                </div>
                <div className="bottom-0 left-0 md:w-[450px] absolute lg:h-[150px] xl:ps-12 md:ps-6 ps-4 w-full md:h-28 h-[80px] xs:h-[72px] bg-[#2f5a33] flex justify-start items-center font-lexend leading-tight md:text-[32px] text-xl xs:text-base font-light text-[#f4e391] ">
                  <h3>
                    The right balance
                    <br />
                    of support and comfort
                  </h3>
                </div>
                <img
                  src={reason_1}
                  alt=""
                  className="object-cover xl:block hidden"
                />
                <img
                  src={reason_small}
                  alt=""
                  className=" w-full xl:hidden sm:h-[250px] block"
                />
              </div>
            </div>
            <div className="text-white xl:w-[720px] md:mt-10 mt-4 xl:mb-0 mb-8 sm:text-base text-lg xs:text-sm font-light ">
              <div>
                <p>
                  {" "}
                  Your spine plays a central role in almost everything you do.
                  <br className="lg:block hidden" />
                  Sitting, walking, bending, even resting.{" "}
                </p>
                <p className="md:mt-8 mt-4">
                  When your mattress doesn’t support it properly, it can lead to
                  discomfort, <br className="lg:block hidden" /> restricted
                  movement, and long-term strain.
                </p>
                <p className="md:mt-8 mt-4">
                  <span className="font-semibold">
                    Moondew natural latex mattress{" "}
                  </span>
                  supports the three essential functions
                  <br className="lg:block hidden" />
                  of your spine:
                </p>
                <ul className="mt-2">
                  <li>
                    {" "}
                    <CircleIcon className="text-sm text-[#f4e391] mr-3" />
                    Safeguarding the connection between the spinal cord and your
                    nervous system
                  </li>
                  <li>
                    {" "}
                    <CircleIcon className="text-sm text-[#f4e391] mr-3" />
                    Maintaining an upright posture through balanced structural
                  </li>
                  <li>
                    <CircleIcon className="text-sm text-[#f4e391] mr-3" />
                    support Allowing flexible, natural movement without strain
                  </li>
                </ul>
                <p className="md:mt-8 mt-4">
                  It gently adapts to your body, helping you rest in a position
                  that feels natural and supported.
                </p>
              </div>
            </div>
          </div>

          <div className="flex xl:flex-row flex-col xl:gap-14 ">
            <div className="3xl:w-[630px] xl:w-[690px] xl:h-[530px] w-full flex justify-start items-center relative overflow-hidden">
              <div className="z-10 relative">
                <div className="absolute right-0 md:w-24 md:h-24 w-12 h-12 bg-[#f4e391] flex justify-center items-center font-lexend md:text-6xl text-3xl font-extralight text-[#2f5a33]">
                  2
                </div>
                <div className="bottom-0 left-0 md:w-[450px] absolute lg:h-[150px] w-full md:h-28 h-[80px] xs:h-[72px] bg-[#2f5a33] flex justify-start xl:ps-12 md:ps-6 ps-4 items-center font-lexend leading-tight md:text-[32px] text-xl xs:text-base font-light text-[#f4e391] ">
                  <h3>
                    Wake up
                    <br />
                    feeling refreshed
                  </h3>
                </div>
                <img
                  src={reason_2_small}
                  alt=""
                  className="object-cover xl:block hidden"
                />
                <img
                  src={reason_2}
                  alt=""
                  className=" w-full xl:hidden sm:h-[220px] block"
                />
              </div>
            </div>
            <div className="text-white xl:w-[720px] md:mt-10 mt-4 xl:mb-0 mb-8 sm:text-base text-lg xs:text-sm font-light ">
              <div>
                <p>
                  {" "}
                  Not everyone experiences deep, uninterrupted sleep.
                  <br className="lg:block hidden" />
                  And over time, poor sleep can affect both your body and mind.
                </p>
                <p className="md:mt-8 mt-4">It may show up as:</p>
                <ul className="mt-2">
                  <li>
                    {" "}
                    <CircleIcon className="text-sm text-[#f4e391] mr-3" />
                    Frequent headaches and fatigue
                  </li>
                  <li>
                    {" "}
                    <CircleIcon className="text-sm text-[#f4e391] mr-3" />
                    Difficulty concentrating and memory issues
                  </li>
                  <li>
                    <CircleIcon className="text-sm text-[#f4e391] mr-3" />
                    Mood swings, anxiety, and low energy
                  </li>
                  <li>
                    <CircleIcon className="text-sm text-[#f4e391] mr-3" />
                    Increased risk of long-term health concerns
                  </li>
                </ul>
                <p className="md:mt-8 mt-4">
                  A Moondew latex mattress is designed to support deeper, more
                  consistent sleep. <br className="lg:block hidden" />
                  So you wake up feeling clearer, lighter, and more refreshed.
                </p>
              </div>
            </div>
          </div>

          <div className="flex xl:flex-row flex-col xl:gap-14 ">
            <div className="3xl:w-[630px] xl:w-[690px] xl:h-[530px] w-full flex justify-start items-center relative overflow-hidden">
              <div className="z-10 relative">
                <div className="absolute right-0 md:w-24 md:h-24 w-12 h-12 bg-[#f4e391] flex justify-center items-center font-lexend md:text-6xl text-3xl font-extralight text-[#2f5a33]">
                  3
                </div>
                <div className="bottom-0 left-0 md:w-[450px] absolute lg:h-[150px] w-full md:h-28 h-[80px] xs:h-[72px] bg-[#2f5a33] flex justify-start xl:ps-12 md:ps-6 ps-4 items-center font-lexend leading-tight md:text-[32px] text-xl xs:text-base font-light text-[#f4e391] ">
                  <h3>
                    A 100% natural
                    <br />
                    and green product
                  </h3>
                </div>
                <img
                  src={reason_3}
                  alt=""
                  className="object-cover xl:block hidden"
                />
                <img
                  src={reason_3_small}
                  alt=""
                  className=" w-full xl:hidden sm:h-[220px]  block"
                />
              </div>
            </div>
            <div className="text-white xl:w-[720px] md:mt-10 mt-4 xl:mb-0 mb-8 sm:text-base text-lg xs:text-sm font-light ">
              <div>
                <p>
                  {" "}
                  A 100% natural latex mattress is made from the sap of rubber
                  trees,
                  <br className="lg:block hidden" />
                  without harmful chemicals or synthetic materials.
                </p>
                <p className="md:mt-8 mt-4">What this means for you:</p>
                <ul className="mt-2">
                  <li>
                    {" "}
                    <CircleIcon className="text-sm text-[#f4e391] mr-3" />
                    No harmful emissions or unwanted odours
                  </li>
                  <li>
                    {" "}
                    <CircleIcon className="text-sm text-[#f4e391] mr-3" />
                    Safe for everyday use, even for children
                  </li>
                  <li>
                    <CircleIcon className="text-sm text-[#f4e391] mr-3" />
                    Naturally hypoallergenic
                  </li>
                  <li>
                    <CircleIcon className="text-sm text-[#f4e391] mr-3" />
                    Biodegradable and environmentally responsible
                  </li>
                </ul>
                <p className="md:mt-8 mt-4">
                  Choosing a Moondew natural latex mattress is a step towards a
                  safer home
                  <br className="lg:block hidden" />
                  and a more conscious way of living.
                </p>
              </div>
            </div>
          </div>

          <div className="flex xl:flex-row flex-col xl:gap-14 ">
            <div className="3xl:w-[630px] xl:w-[690px] xl:h-[530px] w-full flex justify-start items-center relative overflow-hidden">
              <div className="z-10 relative">
                <div className="absolute right-0 md:w-24 md:h-24 w-12 h-12 bg-[#f4e391] flex justify-center items-center font-lexend md:text-6xl text-3xl font-extralight text-[#2f5a33]">
                  4
                </div>
                <div className="bottom-0 left-0 md:w-[450px] absolute lg:h-[150px] w-full md:h-28 h-[80px] xs:h-[72px] bg-[#2f5a33] flex justify-start xl:ps-12 md:ps-6 ps-4 items-center font-lexend leading-tight md:text-[32px] text-xl xs:text-base font-light text-[#f4e391] ">
                  <h3>
                    No dust and mite
                    <br />
                    related allergies
                  </h3>
                </div>
                <img
                  src={reason_4}
                  alt=""
                  className="object-cover xl:block hidden"
                />
                <img
                  src={reason_4_small}
                  alt=""
                  className=" w-full xl:hidden sm:h-[220px]  block"
                />
              </div>
            </div>
            <div className="text-white xl:w-[720px] md:mt-10 mt-4 xl:mb-0 mb-8 sm:text-base text-lg xs:text-sm font-light ">
              <div>
                <p>
                  {" "}
                  Many conventional mattresses can become a space where dust
                  mites
                  <br className="lg:block hidden" />
                  and bacteria build up over time.
                </p>
                <p className="md:mt-8 mt-4">This can lead to:</p>
                <ul className="mt-2">
                  <li>
                    {" "}
                    <CircleIcon className="text-sm text-[#f4e391] mr-3" />
                    Sneezing and nasal irritation
                  </li>
                  <li>
                    {" "}
                    <CircleIcon className="text-sm text-[#f4e391] mr-3" />
                    Itchy skin and discomfort
                  </li>
                  <li>
                    <CircleIcon className="text-sm text-[#f4e391] mr-3" />
                    Red or watery eyes
                  </li>
                  <li>
                    <CircleIcon className="text-sm text-[#f4e391] mr-3" />
                    Breathing difficulties, especially for those with asthma
                  </li>
                </ul>
                <p className="md:mt-8 mt-4">
                  A Moondew latex mattress naturally resists dust mites, mold,
                  and microbes.
                  <br className="lg:block hidden" />
                  It helps create a cleaner sleep environment, reducing
                  disturbances
                  <br className="lg:block hidden" />
                  and improving overall comfort.
                </p>
              </div>
            </div>
          </div>

          <div className="flex xl:flex-row flex-col xl:gap-14 ">
            <div className="3xl:w-[630px] xl:w-[690px] xl:h-[530px] w-full flex justify-start items-center relative overflow-hidden">
              <div className="z-10 relative">
                <div className="absolute right-0 md:w-24 md:h-24 w-12 h-12 bg-[#f4e391] flex justify-center items-center font-lexend md:text-6xl text-3xl font-extralight text-[#2f5a33]">
                  5
                </div>
                <div className="bottom-0 left-0 md:w-[450px] absolute lg:h-[150px] w-full md:h-28 h-[80px] xs:h-[72px] bg-[#2f5a33] flex justify-start xl:ps-12 md:ps-6 ps-4 items-center font-lexend leading-tight md:text-[32px] text-xl xs:text-base font-light text-[#f4e391] ">
                  <h3>
                    Sleep cool, even in hot
                    <br />
                    and humid conditions
                  </h3>
                </div>
                <img
                  src={reason_5}
                  alt=""
                  className="object-cover xl:block hidden"
                />
                <img
                  src={reason_5_small}
                  alt=""
                  className=" w-full xl:hidden sm:h-[220px]  block"
                />
              </div>
            </div>
            <div className="text-white xl:w-[720px] md:mt-10 mt-4 xl:mb-0 mb-8 sm:text-base text-lg xs:text-sm font-light ">
              <div>
                <p>
                  {" "}
                  Waking up feeling hot or sweaty can interrupt your sleep
                  cycle.
                  <br className="lg:block hidden" />
                  and bacteria build up over time.
                </p>

                <p className="md:mt-8 mt-4">
                  Unlike synthetic materials, a natural latex mattress allows
                  air to flow freely. <br className="lg:block hidden" />
                  This helps regulate temperature and prevents heat from getting
                  trapped.
                </p>
                <p className="md:mt-8 mt-4">
                  With a Moondew natural latex mattress, you experience cooler,
                  <br className="lg:block hidden" />
                  more comfortable sleep, even in warm and humid conditions.
                </p>
              </div>
            </div>
          </div>

          <div className="flex xl:flex-row flex-col xl:gap-14 ">
            <div className="3xl:w-[630px] xl:w-[690px] xl:h-[530px] w-full flex justify-start items-center relative overflow-hidden">
              <div className="z-10 relative">
                <div className="absolute right-0 md:w-24 md:h-24 w-12 h-12 bg-[#f4e391] flex justify-center items-center font-lexend md:text-6xl text-3xl font-extralight text-[#2f5a33]">
                  6
                </div>
                <div className="bottom-0 left-0 md:w-[450px] absolute lg:h-[150px] w-full md:h-28 h-[80px] xs:h-[72px] bg-[#2f5a33] flex justify-start xl:ps-12 md:ps-6 ps-4 items-center font-lexend leading-tight md:text-[32px] text-xl xs:text-base font-light text-[#f4e391] ">
                  <h3>
                    Invest in a brand
                    <br />
                    you can trust
                  </h3>
                </div>
                <img
                  src={reason_6}
                  alt=""
                  className="object-cover xl:block hidden"
                />
                <img
                  src={reason_6_small}
                  alt=""
                  className=" w-full xl:hidden sm:h-[220px]  block"
                />
              </div>
            </div>
            <div className="text-white xl:w-[720px] md:mt-10 mt-4 xl:mb-0 mb-8 sm:text-base text-lg xs:text-sm font-light ">
              <div>
                <p> Trust comes from what goes into what you sleep on.</p>

                <p className="md:mt-8 mt-4">
                  Every Moondew natural latex mattress is made using materials
                  certified by globally recognised standards like eco-INSTITUT
                  and OEKO-TEX® STANDARD 100.
                  <br className="lg:block hidden" />
                  These certifications ensure that the latex is low in
                  emissions, free from harmful
                  <br className="lg:block hidden" />
                  substances, and safe for everyday use.
                </p>
                <p className="md:mt-8 mt-4">
                  It’s not just about meeting standards. It’s about making sure
                  that what you bring
                  <br className="lg:block hidden" />
                  into your home is clean, reliable, and built with care.{" "}
                </p>
              </div>
            </div>
          </div>

          <div className="flex xl:flex-row flex-col xl:gap-14 ">
            <div className="3xl:w-[630px] xl:w-[690px] xl:h-[530px] w-full flex justify-start items-center relative overflow-hidden">
              <div className="z-10 relative">
                <div className="absolute right-0 md:w-24 md:h-24 w-12 h-12 bg-[#f4e391] flex justify-center items-center font-lexend md:text-6xl text-3xl font-extralight text-[#2f5a33]">
                  7
                </div>
                <div className="bottom-0 left-0 md:w-[450px] absolute lg:h-[150px] w-full md:h-28 h-[80px] xs:h-[72px] bg-[#2f5a33] flex justify-start xl:ps-12 md:ps-6 ps-4 items-center font-lexend leading-tight md:text-[32px] text-xl xs:text-base font-light text-[#f4e391] ">
                  <h3>
                    Handcrafted
                    <br />
                    in India
                  </h3>
                </div>
                <img
                  src={reason_7}
                  alt=""
                  className="object-cover xl:block hidden"
                />
                <img
                  src={reason_7_small}
                  alt=""
                  className=" w-full xl:hidden sm:h-[220px]  block"
                />
              </div>
            </div>
            <div className="text-white xl:w-[720px] md:mt-10 mt-4 xl:mb-0 mb-8 sm:text-base text-lg xs:text-sm font-light ">
              <div>
                <p>
                  {" "}
                  Each Moondew natural latex mattress is crafted with care,
                  using latex sourced
                  <br className="lg:block hidden" />
                  from the rubber tree plantations of Kerala.
                </p>

                <p className="md:mt-8 mt-4">
                  Known as “God’s own country,” Kerala is home to rich,
                  sustainable landscapes
                  <br className="lg:block hidden" />
                  where latex is harvested responsibly without harming the
                  trees.
                </p>
                <p className="md:mt-8 mt-4">
                  Every mattress reflects this origin, combining natural
                  materials with
                  <br className="lg:block hidden" />
                  thoughtful craftsmanship.{" "}
                </p>
              </div>
            </div>
          </div>

          <div className="flex xl:flex-row flex-col xl:gap-14  ">
            <div className="3xl:w-[630px] xl:w-[690px] xl:h-[530px] w-full flex justify-start items-center relative overflow-hidden">
              <div className="z-10 relative">
                <div className="absolute right-0 md:w-24 md:h-24 w-12 h-12 bg-[#f4e391] flex justify-center items-center font-lexend md:text-6xl text-3xl font-extralight text-[#2f5a33]">
                  8
                </div>
                <div className="bottom-0 left-0 md:w-[450px] absolute lg:h-[150px] w-full md:h-28 h-[80px] xs:h-[72px] bg-[#2f5a33] flex justify-start xl:ps-12 md:ps-6 ps-4 items-center font-lexend leading-tight md:text-[32px] text-xl xs:text-base font-light text-[#f4e391] ">
                  <h3>
                    Enjoy a warranty
                    <br />
                    of 15 years
                  </h3>
                </div>
                <img
                  src={reason_8}
                  alt=""
                  className="object-cover xl:block hidden"
                />
                <img
                  src={reason_8_small}
                  alt=""
                  className=" w-full xl:hidden sm:h-[220px]  block"
                />
              </div>
            </div>
            <div className="text-white xl:w-[720px] md:mt-10 mt-4 xl:mb-0 mb-8 sm:text-base text-lg xs:text-sm font-light ">
              <div>
                <p> A mattress is something you rely on every day.</p>

                <p className="md:mt-8 mt-4">
                  A Moondew latex mattress is built to last, and backed by a
                  long-term warranty
                  <br className="lg:block hidden" />
                  that reflects its durability and performance.
                </p>
                <p className="md:mt-8 mt-4">
                  Because better sleep should come with lasting confidence.
                  <br className="lg:block hidden" />
                  where latex is harvested responsibly without harming the
                  trees.{" "}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Reason8;
